"use strict";
/*
 * Membrane React package
 * {@link https://www.npmjs.com/package/@membranehq/react}
 * v0.29.2
 */
'use client';

function isDefinedValue(value) {
  return value !== null && value !== void 0;
}

export { isDefinedValue };
